import ThemeMachine, { ToThemeIFace, SettableTheme, resetToInitial } from './ThemeMachine';
import defaultThemeDefinition from './themeDefinition.json';

export type DefaultThemeDefinition = typeof defaultThemeDefinition;

export { defaultThemeDefinition as themeDefinition };

export const BaseThemeMachine = new ThemeMachine({ definition: defaultThemeDefinition });

export const WorkTheme = BaseThemeMachine.theme;

const makeResetTheme = (obj: Record<string, unknown>): Record<string, unknown> => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, val]) => {
      if (val && typeof val === 'object')
        return [key, makeResetTheme(val as Record<string, unknown>)];
      return [key, resetToInitial];
    })
  );
};

export const ResetTheme: DefaultSettableTheme = makeResetTheme(WorkTheme);

export const defaultThemeProp = Object.freeze({ theme: WorkTheme });

export type DefaultSettableTheme = SettableTheme<typeof defaultThemeDefinition>;

// https://styled-components.com/docs/api#create-a-declarations-file
declare module 'styled-components' {
  export interface DefaultTheme extends ToThemeIFace<typeof defaultThemeDefinition> {}
}
